module.exports = __webpack_public_path__ + "static/media/view1.43dadba8.jpg";